import {
  GET_ORGANISATION_REQUEST,
  GET_ORGANISATION_SUCCESS,
  GET_USER_ORGANISATION_REQUEST,
  GET_USER_ORGANISATION_SUCCESS,
} from '../constants/actionTypes';

export const getUserOrganisationRequest = (payload) => ({
  type: GET_USER_ORGANISATION_REQUEST,
  payload,
});

export const getUserOrganisationSuccess = (payload) => ({
  type: GET_USER_ORGANISATION_SUCCESS,
  payload,
});

export const getOrganisationRequest = (payload) => ({
  type: GET_ORGANISATION_REQUEST,
  payload,
});

export const getOrganisationSuccess = (payload) => ({
  type: GET_ORGANISATION_SUCCESS,
  payload,
});
